import React, { ChangeEvent } from "react";
import "./input.scss";
interface InputTextProps {
  name?: string;
  type?: string;
  label?: string;
  errors?: boolean;
  errormessage?: any;
  placeholder?: string;
  className?: string;
  required?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string | number | Date;
  isDisable?: boolean;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  inputMode?:
    | "none"
    | "text"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal"
    | "search";
  step?: string;
  decimalScale?: number;
}

const InputText: React.FC<InputTextProps> = ({
  name,
  type = "text",
  label = "name",
  errors,
  errormessage,
  placeholder = "",
  className,
  required = false,
  onChange,
  value,
  isDisable,
  onFocus,
  onBlur,
  inputMode,
  step,
  decimalScale,
}) => {
  const handleChange = (e: any) => {
    if (e.target.type === "number") {
      e.target.value = e.target.value.replace(/e/g, "");

      const decimalRegex =
        typeof decimalScale === "number"
          ? new RegExp(`^\\d{0,9}(\\.\\d{0,${decimalScale}})?$`)
          : /^\d{0,9}$/;

      if (decimalRegex.test(e.target.value)) {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  return (
    <div className="form__group">
      <label className={`${className} form__label ${required ? "endDot" : ""}`}>
        {label}
      </label>
      <input
        name={name}
        onChange={handleChange}
        value={
          value instanceof Date ? value.toISOString().substr(0, 10) : value
        }
        onFocus={onFocus}
        required={required}
        disabled={isDisable}
        className={`form__field ${errors ? "mandatory_input" : ""}`}
        type={type}
        placeholder={placeholder}
        autoComplete="off"
        onBlur={onBlur}
        inputMode={inputMode}
        step={step}
      />
      {errors && (
        <label className="form__label__error">
          {errormessage ? errormessage : `${label} is mandatory`}
        </label>
      )}
    </div>
  );
};

export default React.memo(InputText);
